import type { ReactElement } from 'react';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

import { useChatBranding } from '../ChatProvider';
import { MarkdownMessage } from './MarkdownMessage';

export function WelcomeView(): ReactElement {
  const branding = useChatBranding();

  return (
    <div
      className="motion-safe:animate-in motion-safe:fade-in motion-safe:duration-500 flex flex-1 flex-col justify-center gap-6 overflow-y-auto px-5 py-7"
      data-slot="welcome-view"
    >
      <div className="mx-auto flex w-full max-w-2xl flex-col items-center gap-4 text-center">
        <Avatar className="ring-primary/15 ring-offset-background size-14 ring-2 ring-offset-2">
          <AvatarImage src={branding.logo} alt="" />
          <AvatarFallback className="bg-primary text-primary-foreground text-base font-semibold">
            {initials(branding.title)}
          </AvatarFallback>
        </Avatar>
        <MarkdownMessage text={branding.welcomeMessage} />
      </div>
    </div>
  );
}

function initials(name: string): string {
  return name
    .split(/\s+/)
    .map((w) => w[0] ?? '')
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}
